<app-toast-msg></app-toast-msg>
<app-loader></app-loader>
<router-outlet></router-outlet>
